module.exports = __webpack_public_path__ + "img/path-close-circle-outline.6a02ca1d.svg";